import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/actions/Button'
interface Props {
	chargingPlan: any
}

const SmartChargingInfo = ({ chargingPlan }: Props) => {
	interface ChargingInfoProps {
		label: string
		value: string | null | number | undefined
	}

	const { t } = useTranslation('pages_electricCar', { keyPrefix: 'smartChargingVisualiser' })

	const [additionalInfoOpen, setAdditionalInfoOpen] = useState(false)

	const ChargingInfo: React.FC<ChargingInfoProps> = ({ label, value }) => (
		<div className='charging-info text-white'>
			<div className='text'>{label}</div>
			<div className='numbers'>{value || 'N/A'}</div>
		</div>
	)

	return (
		<div className='additional'>
			<div className='info mx-4'>
				{!additionalInfoOpen ? (
					<Button className='hollow m-0' onClick={() => setAdditionalInfoOpen(true)}>
						{t('lisatiedot')}
					</Button>
				) : (
					<>
						<ChargingInfo
							label={t('chargingStopped')}
							value={chargingPlan.stopAt ? dayjs(chargingPlan.stopAt).format('HH:mm') : 'N/A'}
						/>
						<ChargingInfo
							label={t('chargingStarted')}
							value={chargingPlan.startAt ? dayjs(chargingPlan.startAt).format('HH:mm') : 'N/A'}
						/>
						<ChargingInfo
							label={t('chargingEstimatedFinish')}
							value={
								chargingPlan.estimatedFinishAt
									? dayjs(chargingPlan.estimatedFinishAt).format('HH:mm')
									: 'N/A'
							}
						/>
						<ChargingInfo
							label={t('chargingEstimatedChargeTime')}
							value={
								chargingPlan.chargeTime
									? `${chargingPlan.chargeTime.hours}h ${chargingPlan.chargeTime.minutes}min`
									: 'N/A'
							}
						/>
						<ChargingInfo
							label={t('chargingEstimatedCost')}
							value={chargingPlan.smartCost ? `${chargingPlan.smartCost.toFixed(2)}€` : 'N/A'}
						/>
						<ChargingInfo
							label={t('chargingEstimatedSaving')}
							value={
								chargingPlan.nonSmartCost && chargingPlan.smartCost
									? `${(chargingPlan.nonSmartCost - chargingPlan.smartCost).toFixed(2)}€`
									: 'N/A'
							}
						/>
						<Button className='hollow m-0' onClick={() => setAdditionalInfoOpen(false)}>
							{t('piilotalisatiedot')}
						</Button>
					</>
				)}
			</div>
		</div>
	)
}

export default SmartChargingInfo
